import dayjs from 'dayjs'
import { UpdatedPrices } from './checkout-prices'
import { DateRange } from '../types/dates'

export function getTotalDiscountsFromUpdatedPrices(data: UpdatedPrices): number {
  return data.fees.reduce((acum, fee) => {
    if (fee.fee?.includes('-')) {
      const actual = Number(fee.fee.replace(/[^0-9.]+/g, ''))
      return acum + actual
    }
    return acum
  }, 0)
}

export function getDurationDiscountCoupon(data: UpdatedPrices, dateRange: DateRange): string {
  const durationDiscount = data.fees.filter((fee) => fee.discount?.toLowerCase().includes('duration'))
  if (durationDiscount.length > 0) {
    const duration = dayjs(dateRange.to).diff(dayjs(dateRange.from, 'hours'))
    return duration >= 4 ? '20% off for 4+ hours' : duration >= 8 ? '25% off for 8+ hours' : ''
  }
  return ''
}
